module.exports = __webpack_public_path__ + "img/restart.b1fa5567.png";